import styled from 'styled-components';

export const CookieWrap = styled.section`
  align-items: center;
  background: ${props => props.theme.colors.backgroundLighter1};
  border-bottom: 3px solid ${props => props.theme.colors.primary};
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  left: 0;
  padding: 1rem;
  position: fixed;
  right: 0;
  z-index: 2;
`;

export const CookieText = styled.p`
  font-size: 12px;
  font-weight: 700;
  margin: 0 1rem;
  max-width: ${props => props.theme.breakpoints.med};
  padding: 0;
  text-align: left;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.med}) {
    font-size: 14px;
  }
`;

export const CookieButton = styled.button`
  background: ${props => props.theme.colors.backgroundLighter1};
  border-radius: 50px;
  border: 2px solid ${props => props.theme.colors.primary};
  font-size: 12px;
  margin: 0 1rem 0 0;
  padding: 5px 20px;

  @media screen and (min-width: ${props => props.theme.breakpoints.med}) {
    font-size: 15px;
    margin: 0 1rem;
    padding: 5px 40px;
  }

  &:hover {
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.backgroundLighter1};
  }
`;



// WEBPACK FOOTER //
// ./src/components/cookie-consent/CookieConsent.styled.js